/**
 * @file Configuration overrides for the client.
 */

/**
 * @typedef {object} NetworkConfig
 * @property {string} patientDataUrl Gateway URL to fetch patient data.
 * @property {string} patientSummaryUrl Gateway URL to create a patient summary record.
 * @property {string} patientSummaryManifestUrl Gateway URL to fetch patient summary manifest data.
 * @property {string} patientSummaryViewerUrl URL to Patient Summary Viewer web application.
 * @property {string} medicationUrl Gateway URL to fetch medication data.
 * @property {string} immunizationUrl Gateway URL to fetch immunization data.
 * @property {string} observationUrl Gateway URL to fetch lab result data.
 * @property {string} imagingUrl Gateway URL to fetch imaging data.
 * @property {string} loginUrl Gateway URL to authenticate with OAuth credentials.
 * @property {string} loginProviderType OIDC provider type.
 * @property {string} apiKey Gateway service API token.
 * @property {string} authorizeUrl OAuth provider URL.
 * @property {string} baseScopes Scopes to request for all users.
 * @property {string} labResultsScope Scopes to request if access to lab results module is enabled.
 * @property {string} imagingScope Scopes to request if access to imaging module is enabled.
 * @property {string} immunizationsScope Scopes to request if access to immunization module is enabled.
 * @property {string} medicationsScope Scopes to request if access to medications module is enabled.
 * @property {string} clientId OAuth client ID.
 * @property {string} redirectUri Redirect to this URI on successful OAuth authentication.
 * @property {string} salesforcePortal URL to Salesforce site with embedded MyHealth window.
 */

/** @type {NetworkConfig} */
const networkConfig = {
  patientDataUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/patient/',
  patientSummaryUrl: 'https://pancanadianio.ca:10309/api/shl',
  patientSummaryManifestUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/patient-summary/manifest/',
  patientSummaryViewerUrl: 'https://ps-viewer.dev.myhealth.infoway.vsfcloud.com/',
  patientSummaryRevokeUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/patient-summary/manifest/revoke-access',
  medicationUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/medication/',
  immunizationUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/immunization/',
  observationUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/diagnosticReport/',
  imagingUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/diagnosticImagingReport/',
  loginUrl: 'https://dev.myhealth.infoway.vsfcloud.com/myhealth-gateway/v1/authentication/login',
  loginProviderType: 'myhealth_broker_dev',
  apiKey: process.env.REACT_APP_API_KEY,
  authorizeUrl: 'https://iam.dev.gaas.gnb-doh.vsfcloud.com/auth/realms/gaas_idp_1/protocol/openid-connect/auth',
  baseScopes: 'openid gnb.ca/health user/Patient.s gnb.ca/health/role/person CAFEX-2', 
  labResultsScope: 'user/DiagnosticReport.s',
  imagingScope: 'user/DiagnosticReport.s',
  immunizationsScope: 'user/Immunization.s',
  medicationsScope: 'user/MedicationRequest.s',
  clientId: 'myhealth',
  redirectUri: 'https://myhealth-web.dev.myhealth.infoway.vsfcloud.com/',
  salesforcePortal: 'https://myhealth-projst.gnb.ca/s/',
};

export default networkConfig;
